import { useSelector } from 'react-redux'

import type CallV2State from 'store/callV2/callV2.state'
import type RootState from 'store/state'

const useCallV2 = (): CallV2State => useSelector((state: RootState) => state.callV2)

export default useCallV2
